/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon24Solid = forwardRef('MathDeltaIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.882 3.272c.903-1.695 3.333-1.695 4.236 0l8.099 15.199C23.069 20.07 21.91 22 20.099 22H3.9c-1.812 0-2.97-1.93-2.118-3.53L9.882 3.273ZM9.804 9.07a.75.75 0 0 1 1.321 0l4.882 9.075a.75.75 0 0 1-.66 1.105H5.582a.75.75 0 0 1-.66-1.105L9.804 9.07Z" })));
});
